import { useState, useEffect, useMemo } from "react";
import {
  CommonImages,
  UserEngagement,
  MonitizationIcons,
  UserAuqisitation,
} from "../../../../reusableUI/images";
import Card from "../../../../reusableUI/CommonCardUi";
import SmallCard from "../../../../reusableUI/smallCard";
import CommonDropdown from "../../../../reusableUI/dropdown";
import RevenueOverviewChartNursePhysio from "../../../../Charts/revenueHCP";

import moment from "moment";
// import UserGender from "../../../Charts/userGender";
import PremiumUsersChart from "../../../../Charts/premiumUsers";
import { getAllAmount } from "../../../../Service/monetization";
import Loader from "../../../../reusableUI/loader";
import { nurseData } from "../datas";
// import Age from "../../../Charts/ageChart";
// import GeneralRole from "../../../Charts/userByRole";
// import CountryList from "../../reusableUI/countryList";
// import IndiaFlag from "../../assets/common/IN.png";
// import UsFlag from "../../assets/common/US.png";

const Monitization = () => {
  const [selectedValue, setSelectedValue] = useState("Last 30 days");
  const [card, setCard] = useState("1");
  const [data, setData] = useState([]);
  const [last30, setLast30] = useState([]);
  const [last7, setLast7] = useState([]);
  const [today, setToday] = useState([]);
  const [overAll, setOverAll] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastTodayTotalAmount, setTodayAmountTotal] = useState(0);
  const [last7TotalAmount, setLast7AmountTotal] = useState(0);
  const [last30TotalAmount, setLast30AmountTotal] = useState(0);
  const [overAllTotalAmount, setOverAllAmountTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalSuccessAmount, setTotalSuccessfullAmount] = useState(0);
  const [totalFailedAmount, setTotalFailedAmount] = useState(0);
  const [totalNurseCareAmount, setTotalNurseCareAmount] = useState(0);
  const [totalPhysioCareAmount, setTotalPhysioCareAmount] = useState(0);

  useEffect(() => {
    getAllRevenue();
  }, []);

  useEffect(() => {
    updateAmountBasedOnSelection();
  }, [selectedValue, today, last7, last30, overAll]);

  const getAllRevenue = async () => {
    try {
      const res = await getAllAmount();
      console.log(res)
      if (!res.error) {
        setLoading(false);
        setData(res.data);
        calculateDuration(res.data.payments);
      }
    } catch (e) {
      console.log(e);
    }
  };
  // console.log(data);

  const calculateDuration = (paymentData) => {
    const now = moment();

    const today = paymentData.filter((element) => {
      const sessionDate = moment.unix(element.created_at);
      return sessionDate.isSame(now, "day");
    });

    const last7 = paymentData.filter((element) => {
      const sessionDate = moment.unix(element.created_at);
      return sessionDate.isAfter(now.clone().subtract(7, "days"));
    });

    const last30 = paymentData.filter((element) => {
      const sessionDate = moment.unix(element.created_at);
      return sessionDate.isAfter(now.clone().subtract(30, "days"));
    });

    const overAll = [...paymentData];

    setToday(today);
    setLast7(last7);
    setLast30(last30);
    setOverAll(overAll);

    // Set precomputed totals (optional)
    setTodayAmountTotal(
      today.reduce((sum, item) => sum + (item.amount || 0), 0)
    );
    setLast7AmountTotal(
      last7.reduce((sum, item) => sum + (item.amount || 0), 0)
    );
    setLast30AmountTotal(
      last30.reduce((sum, item) => sum + (item.amount || 0), 0)
    );
    setOverAllAmountTotal(
      overAll.reduce((sum, item) => sum + (item.amount || 0), 0)
    );
  };

  const updateAmountBasedOnSelection = () => {
    let totalAmount = 0;

    const getTotal = (data) =>
      data.reduce((sum, item) => {
        if (item.status === "captured" && typeof item.amount === "number") {
          return sum + item.amount;
        }
        return sum;
      }, 0);

    if (selectedValue === "Last 30 days") {
      totalAmount = getTotal(last30);
    } else if (selectedValue === "Last 7 days") {
      totalAmount = getTotal(last7);
    } else if (selectedValue === "Today") {
      totalAmount = getTotal(today);
    } else if (selectedValue === "Over All") {
      totalAmount = getTotal(overAll);
    }

    setTotalAmount(totalAmount);

    let totalSuccessAmount = 0;

    if (selectedValue === "Last 30 days") {
      totalSuccessAmount = last30
        .filter((item) => item.status === "captured")
        .reduce((sum, item) => sum + (item.amount || 0), 0);
    } else if (selectedValue === "Last 7 days") {
      totalSuccessAmount = last7
        .filter((item) => item.status === "captured")
        .reduce((sum, item) => sum + (item.amount || 0), 0);
    } else if (selectedValue === "Today") {
      totalSuccessAmount = today
        .filter((item) => item.status === "captured")
        .reduce((sum, item) => sum + (item.amount || 0), 0);
    } else if (selectedValue === "Over All") {
      totalSuccessAmount = overAll
        .filter((item) => item.status === "captured")
        .reduce((sum, item) => sum + (item.amount || 0), 0);
    }

    setTotalSuccessfullAmount(totalSuccessAmount);

    let totalFailedAmount = 0;

    if (selectedValue === "Last 30 days") {
      totalSuccessAmount = last30
        .filter((item) => item.status === "failed")
        .reduce((sum, item) => sum + (item.amount || 0), 0);
    } else if (selectedValue === "Last 7 days") {
      totalSuccessAmount = last7
        .filter((item) => item.status === "failed")
        .reduce((sum, item) => sum + (item.amount || 0), 0);
    } else if (selectedValue === "Today") {
      totalSuccessAmount = today
        .filter((item) => item.status === "failed")
        .reduce((sum, item) => sum + (item.amount || 0), 0);
    } else if (selectedValue === "Over All") {
      totalSuccessAmount = overAll
        .filter((item) => item.status === "failed")
        .reduce((sum, item) => sum + (item.amount || 0), 0);
    }

    setTotalFailedAmount(totalFailedAmount);

    let totalNurseCareAmount = 0;

    const calculateFilteredAmount = (list) =>
      list
        .filter(
          (item) =>
            item?.notes?.mode === "nurse-visit" && item?.status === "captured"
        )
        .reduce((sum, item) => sum + (item.amount || 0), 0);

    if (selectedValue === "Last 30 days") {
      totalNurseCareAmount = calculateFilteredAmount(last30);
    } else if (selectedValue === "Last 7 days") {
      totalNurseCareAmount = calculateFilteredAmount(last7);
    } else if (selectedValue === "Today") {
      totalNurseCareAmount = calculateFilteredAmount(today);
    } else if (selectedValue === "Over All") {
      totalNurseCareAmount = calculateFilteredAmount(overAll);
    }

    setTotalNurseCareAmount(totalNurseCareAmount);

    let totalPhysioCareAmount = 0;

    const calculateFilteredAmountPhysio = (list) =>
      list
        .filter(
          (item) =>
            item?.notes?.mode === "physiotherapist-visit" &&
            item?.status === "captured"
        )
        .reduce((sum, item) => sum + (item.amount || 0), 0);

    if (selectedValue === "Last 30 days") {
      totalPhysioCareAmount = calculateFilteredAmountPhysio(last30);
    } else if (selectedValue === "Last 7 days") {
      totalPhysioCareAmount = calculateFilteredAmountPhysio(last7);
    } else if (selectedValue === "Today") {
      totalPhysioCareAmount = calculateFilteredAmountPhysio(today);
    } else if (selectedValue === "Over All") {
      totalPhysioCareAmount = calculateFilteredAmountPhysio(overAll);
    }

    setTotalPhysioCareAmount(totalPhysioCareAmount);
  };
  console.log(data);

  const handleDropdownChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const options = [
    { label: "Today", value: "Today" },
    { label: "Last 7 days", value: "Last 7 days" },
    { label: "Last 30 days", value: "Last 30 days" },
    { label: "Over All", value: "Over All" },
  ];

  const formatDataWithDateTime = (data) => {
    if (!Array.isArray(data)) {
      console.error("Data is not an array:", data);
      return [];
    }

    return data.map((item) => {
      const formattedDateTime = item.created_at
        ? moment.unix(item.created_at).toISOString()
        : null;

      return {
        ...item,
        dateTime: formattedDateTime,
      };
    });
  };

  const nurseData = Array.isArray(data?.payments)
    ? data.payments.filter(
      (item) =>
        item?.notes?.mode === "nurse-visit" && item?.status === "captured"
    )
    : [];

  const physioData = Array.isArray(data?.payments)
    ? data.payments.filter(
      (item) =>
        item?.notes?.mode === "physiotherapist-visit" &&
        item?.status === "captured"
    )
    : [];

  const formattedNurseData = formatDataWithDateTime(nurseData);
  const formattedPhysioData = formatDataWithDateTime(physioData);

  console.log(totalPhysioCareAmount);

  return (
    <div>
      {loading ? (
        <div className="">
          <Loader loading={loading} page={"monetization"} />
        </div>
      ) : (
        <div className="bg-[#F3F6F5] overflow-y-auto overflow-x-hidden w-[99%] pb-40 mb-10 h-[90vh]">
          <div className="flex flex-wrap mb-2 bg-[#F3F6F5] w-full">
            <Card
              title={"Revenue Generated"}
              image={MonitizationIcons.generated}
              image1={CommonImages.Up}
              count={`₹ ${data.total_collected}`}
              text={"Higher than usual"}
              id="1"
              user={"engagement"}
              size={"revenue"}
            />
            {/* <Card
          title={"Our revenue"}
          image={MonitizationIcons.ourRevenue}
          image1={CommonImages.Up}
          count={data.successfulPayments}
          text={`${data.successfulPayments} paid users out of ${data?.paymentDetails?.length}`}
          id="2"
          user={"engagement"}
          size={"revenue"}
        /> */}
            <Card
              title={"Rewards paid"}
              image={MonitizationIcons.reward}
              image1={CommonImages.Up}
              count={`₹ ${0}`}
              text={`${data.successfulPayments} paid users out of ${data?.paymentDetails?.length}`}
              id="2"
              user={"engagement"}
              size={"revenue"}
            />
          </div>
          {card === "1" && (
            <div className=" h-[70vh]   w-[100%]">
              <div className="bg-[#F3F6F5]">
                <div className="bg-white  rounded-2xl  shadow-lg  m-2">
                  <div className="flex justify-between items-center p-2">
                    <p className="text-[14px] ml-5 mt-[-5px] font-semibold">
                      Revenue
                    </p>

                    <CommonDropdown
                      options={options}
                      value={selectedValue}
                      onChange={handleDropdownChange}
                    />
                  </div>
                  <div className="border-b border-[#D7E4EB] mb-4 mt-[-5px]"></div>
                  <div className="text-center mt-[-20px]">
                    <p className="text-2xl font-bold mt-10">
                      ₹{totalAmount.toFixed(2)}
                    </p>
                    <p className="mt-[-0px] text-sm text-[#1D1D22]">
                      Total Revenue
                    </p>
                  </div>
                  <div className="flex flex-wrap m-4">
                    <SmallCard
                      image1={MonitizationIcons.paySuccess}
                      status={"Successful payment"}
                      count={"₹" + totalSuccessAmount.toFixed(2)}
                      rating={"0%"}
                    />
                    <SmallCard
                      image1={MonitizationIcons.payFailed}
                      status={"Failed payment"}
                      count={"₹" + totalFailedAmount.toFixed(2)}
                      rating={"0%"}
                    />
                  </div>
                  <div className="flex flex-wrap mt-[-30px] m-4">
                    <SmallCard
                      image1={MonitizationIcons.nursePay}
                      status={"Nursing care"}
                      count={"₹" + totalNurseCareAmount.toFixed(2)}
                      rating={"0%"}
                    />
                    <SmallCard
                      image1={MonitizationIcons.phsioPay}
                      status={"Physiotherapy care"}
                      count={"₹" + totalPhysioCareAmount.toFixed(2)}
                      rating={"0%"}
                    />
                  </div>
                </div>
                <div className="bg-white mt-[-5px] rounded-2xl shadow-lg m-2 ">
                  <div className="flex justify-between items-center">
                    <p className="text-[14px] ml-3 p-3 font-semibold">
                      Revenue Overview
                    </p>
                  </div>
                  <div className="border-b border-[#D7E4EB] "></div>
                  <div className="flex mb-2 mt-2 ml-5">
                    <div className="flex items-center">
                      <img
                        src={CommonImages.playStore}
                        alt="Patient"
                        className="h-2 w-2"
                      />
                      <p className="ml-2 text-[12px]">Nurse</p>
                    </div>
                    <div className="flex items-center ml-4">
                      <img
                        src={UserAuqisitation.purpel}
                        alt="Patient"
                        className="h-2 w-2"
                      />
                      <p className="ml-2 text-[12px]">Patient</p>
                    </div>
                  </div>
                  <div className="w-[98%]  mt-4 mb-[120px] pb-4 ml-2">
                    <RevenueOverviewChartNursePhysio
                      value={selectedValue}
                      nurseData={formattedNurseData}
                      physioData={formattedPhysioData}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-start ml-2 w-full mb-[70px] mt-[-45px]">
                {/* <Age registrations={usersAgeData} /> */}
                {/* <GeneralRole values={selectedValue} nurseData={[]} patientData={[]} />
            <UserGender users={[]} /> */}
              </div>
              <div className="mt-[12px]">
                {/* <CountryList countries={countries} title={"Users by Countries"} /> */}
              </div>
            </div>
          )}
          {card === "2" && (
            <div className=" h-[70vh] pt-4 mt-[-10px]">
              <div className="bg-[#F3F6F5]">
                <div className="bg-white rounded-2xl  shadow-lg m-2">
                  <div className="flex justify-between items-center mt-[-20px]">
                    <p className="text-[14px] font-semibold ml-5 mt-[-5px]">
                      Number of Paid Users
                    </p>

                    <div className="mt-[-10px] mr-1">
                      <CommonDropdown
                        options={options}
                        value={selectedValue}
                        onChange={handleDropdownChange}
                      />
                    </div>
                  </div>
                  <div className="border-b border-[#D7E4EB] mb-2 mt-[-5px]"></div>
                  <div className="text-center mt-[-20px]">
                    <p className="text-3xl font-bold mt-10">2,845</p>
                    <p className="mt-[-0px] text-sm text-[#1D1D22]">
                      Total Bookings
                    </p>
                  </div>
                  <div className="flex flex-wrap m-4">
                    <SmallCard
                      image1={UserEngagement.chart}
                      status={"Paid users"}
                      count={"18%"}
                      image2={CommonImages.Up}
                    />
                    <SmallCard
                      image1={UserEngagement.userT}
                      status={"Users without paying"}
                      count={"78"}
                      image2={CommonImages.Up}
                    />
                  </div>
                </div>
                <div className="bg-white my-5  rounded-2xl shadow-lg m-2 mt-[-5px]">
                  <div className="flex justify-between items-center">
                    <p className="text-[14px] ml-3 p-3 font-semibold">
                      Premium users
                    </p>
                  </div>
                  <div className="border-b border-[#D7E4EB] "></div>
                  <div className="w-full">
                    <div className="p-2 mb-[60px]">
                      <PremiumUsersChart />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-center items-center">
                {/* <Age registrations={usersAgeData} /> */}
                {/* <GeneralRole /> */}
                {/* <UserGender /> */}
              </div>
              {/* <CountryList countries={countries} title={"Users by Countries"} /> */}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Monitization;
